export default "__VITE_ASSET__CD3MH5fq__"